import { createHttpLink } from '@apollo/client'

const APP_SERVER_GRAPHQL_URL = `${import.meta.env.VITE_SERVER_URL}/graphql`

export const httpLink = createHttpLink({
  uri: APP_SERVER_GRAPHQL_URL,
})
